"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createChannel = void 0;
/* eslint-disable @typescript-eslint/ban-types */

var PropTypes = __importStar(require("prop-types"));

var react_1 = __importDefault(require("react"));

var decorators_1 = require("./decorators");

function createChannel(channelName, defaultValue) {
  var _a;

  var contextTypes = (_a = {}, _a[channelName] = PropTypes.any, _a);

  var Broadcast =
  /** @class */
  function (_super) {
    __extends(Broadcast, _super);

    function Broadcast() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    Broadcast.prototype.getChildContext = function () {
      var _a;

      return _a = {}, _a[channelName] = this.props.channelValue, _a;
    };

    Broadcast.prototype.render = function () {
      return react_1.default.Children.only(this.props.children);
    };

    Broadcast.childContextTypes = contextTypes;
    return Broadcast;
  }(react_1.default.Component);

  var getDisplayName = function getDisplayName(componentDisplayName) {
    var upperCaseChannelName = channelName.charAt(0).toUpperCase() + channelName.slice(1);
    return "with" + upperCaseChannelName + "(" + componentDisplayName + ")";
  };

  var withChannel = function withChannel(mapChannelToProps) {
    return decorators_1.createDecorator(function (Component) {
      var _a;

      return _a =
      /** @class */
      function (_super) {
        __extends(Subscriber, _super);

        function Subscriber() {
          return _super !== null && _super.apply(this, arguments) || this;
        }

        Subscriber.prototype.render = function () {
          var _a = this,
              context = _a.context,
              props = _a.props;

          var channelValue = context[channelName];
          return react_1.default.createElement(Component, __assign({}, mapChannelToProps(typeof channelValue === 'undefined' ? defaultValue : channelValue, props), props));
        };

        return Subscriber;
      }(react_1.default.Component), _a.displayName = getDisplayName(Component.displayName || Component.name || 'Component'), _a.contextTypes = contextTypes, _a.NakedComponent = Component.NakedComponent || Component, _a;
    });
  };

  return {
    Broadcast: Broadcast,
    withChannel: withChannel
  };
}

exports.createChannel = createChannel;